export class InvalidSessionError extends Error {
  constructor(message: string | undefined, options?: ErrorOptions) {
    super(message, options)
    this.name = `InvalidSessionError`
  }
}

export class APIQueryError extends Error {
  constructor(message: string | undefined, options?: ErrorOptions) {
    super(message, options)
    this.name = `APIQueryError`
  }
}

export class APIMutationError extends Error {
  constructor(message: string | undefined, options?: ErrorOptions) {
    super(message, options)
    this.name = `APIMutationError`
  }
}

export class RegistrationClosedError extends Error {
  constructor(message: string | undefined, options?: ErrorOptions) {
    super(message, options)
    this.name = `RegistrationClosedError`
  }
}

export const MAX_NETWORK_RETRIES = 2

/**
 * React Query `retry` predicate that retries only transient network failures.
 * `fetch` rejects with a `TypeError` ("Failed to fetch", "Load failed", "NetworkError ...") when no HTTP
 * response is received — common on flaky mobile connections. HTTP error responses (401/404/etc.) are thrown
 * as plain `Error`s by the API layer and fail fast.
 */
export function retryOnNetworkError(failureCount: number, error: Error): boolean {
  return error instanceof TypeError && failureCount < MAX_NETWORK_RETRIES
}
